









































































import Vue, { PropType } from "vue";
import VcDate from "@/components/Date/Date.vue";
import VcPrice from "@/components/Price/Price.vue";

export interface PauseContractCard {
  lang: any;
  contractNumber: string;
  contractTitle: string;
  contractDescription: string;
  contractStatus: string;
  pauseStartAt: number;
  resumeAt: number;
  price: number;
  currencyCode: string;
  settlementScheduledAt: number;
}

export default Vue.extend({
  name: "vc-pause-contract-card",
  components: { VcPrice, VcDate },
  props: {
    lang: {
      type: Object as PropType<PauseContractCard["lang"]>,
      default: () => {}
    },
    contractNumber: {
      type: String as PropType<PauseContractCard["contractNumber"]>,
      default: ""
    },
    contractTitle: {
      type: String as PropType<PauseContractCard["contractTitle"]>,
      default: ""
    },
    contractDescription: {
      type: String as PropType<PauseContractCard["contractDescription"]>,
      default: ""
    },
    contractStatus: {
      type: String as PropType<PauseContractCard["contractStatus"]>,
      default: ""
    },
    pauseStartAt: {
      type: Number as PropType<PauseContractCard["pauseStartAt"]>,
      default: 0
    },
    resumeAt: {
      type: Number as PropType<PauseContractCard["resumeAt"]>,
      default: 0
    },
    price: {
      type: Number as PropType<PauseContractCard["price"]>,
      default: 0
    },
    currencyCode: {
      type: String as PropType<PauseContractCard["currencyCode"]>,
      default: ""
    },
    settlementScheduledAt: {
      type: Number as PropType<PauseContractCard["settlementScheduledAt"]>,
      default: 0
    }
  }
});
